export type FirebaseEnvironment = 'production' | 'staging';

interface ResolveFirebaseEnvironmentOptions {
  configuredEnvironment?: string;
  nodeEnvironment?: string;
}

export const resolveFirebaseEnvironment = ({
  configuredEnvironment,
  nodeEnvironment,
}: ResolveFirebaseEnvironmentOptions): FirebaseEnvironment => {
  if (
    configuredEnvironment === 'production' ||
    configuredEnvironment === 'staging'
  ) {
    return configuredEnvironment;
  }

  // Local Vite/Jest sessions historically use the dev Firebase project. Keep
  // that behaviour, while release builds declare their Firebase identity
  // explicitly in package.json instead of inferring it from NODE_ENV. Both
  // staging and production `vite build` commands set NODE_ENV=production.
  return nodeEnvironment === 'production' ? 'production' : 'staging';
};
